/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Sendertopicname2Inputs */

const en_entity_sendertopicname2 = /** @type {(inputs: Entity_Sendertopicname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sender Topic Name`)
};

const de_entity_sendertopicname2 = /** @type {(inputs: Entity_Sendertopicname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sender Topic Name`)
};

/**
* | output |
* | --- |
* | "Sender Topic Name" |
*
* @param {Entity_Sendertopicname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_sendertopicname2 = /** @type {((inputs?: Entity_Sendertopicname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Sendertopicname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_sendertopicname2(inputs)
	return de_entity_sendertopicname2(inputs)
});
export { entity_sendertopicname2 as "entity_senderTopicName" }